module.exports = __webpack_public_path__ + "media/images/blue-lock-d744e9d1bca1f84572546df48a9965a1.jpg";